import { Component, Inject, OnInit } from '@angular/core';
import { NonNcscopeService } from '@shared/service/non-ncscope.service';
import { CustomMessages } from '../custom-messages/custom-messages';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { AuditorBenchService } from 'app/service/auditor-bench-service';
import { AuditBenchSummaryInputDTO } from 'app/model/audit-bench-summary-input-dto';
import { AuditSummaryItemCountBean } from 'app/model/audit-summary-item-count-bean';
import { ComboPopulation } from 'app/model/combo-population';
import { TranslatePipe } from '@shared/pipes/translate.pipe';
import { EasyDialog } from '../easy-dialog/easy-dialog';
@Component({
  selector: 'app-non-ncscope',
  templateUrl: './non-ncscope.component.html',
  styleUrls: ['./non-ncscope.component.scss'],
  providers: [TranslatePipe],
})
export class NonNcscopeComponent implements OnInit {
  parsedJson: any;
  ELEMENT_DATA: any;
  isItemClosed: string = '0';
  ratingList: ComboPopulation[];
  selectedId: number;
  auditId: string;
  auditSummaryItemCountBean: AuditSummaryItemCountBean;
  auditBenchSummaryInputDTO: AuditBenchSummaryInputDTO = new AuditBenchSummaryInputDTO();
  constructor(
    private NonNcscopeService: NonNcscopeService,
    public dialog: EasyDialog,
    private ts: TranslatePipe,
    private customMessage: CustomMessages,
    private dialogRef: MatDialogRef<NonNcscopeComponent>,
    private auditorBenchService: AuditorBenchService,
    @Inject(MAT_DIALOG_DATA) public recievedData: any
  ) {
    this.auditId = recievedData.auditProgramId;
    this.auditSummaryItemCountBean = recievedData.auditSummaryItemCountBean;
    this.isItemClosed = recievedData.isItemCLosed;
  }

  ngOnInit() {
    this.getRating();
  }

  closePopup() {
    this.dialogRef.close({ event: this.isItemClosed });
    return false;
  }

  getID(element) {
    this.selectedId = element.id;
  }

  getRating() {
    this.auditBenchSummaryInputDTO.auditId = this.auditId;
    this.NonNcscopeService.getList(this.auditBenchSummaryInputDTO).subscribe((data: any) => {
      this.ratingList = data;
      //Set Default ID for Acceptable Controls, By Default Acceptable Controls is checked
      if (this.ratingList != null && this.ratingList != undefined) {
        this.selectedId = this.ratingList[0].id;
      }
    });
  }

  saveButtonConfirmation() {
    let obj = this;
    obj.dialog.confirm(
      obj.ts.transform('cams.label.common.confirm'),
      obj.ts.transform('cams.label.auditorSummary.confirmationToCloseAllNonNcItems'),
      async function() {
        obj.saveButton('C');
        //dialogRef.disableClose = true;
      },
      function() {
        //ACTION: Do this if user says NO
        //that.name = "No clicked";
      }
    );
  }

  saveButton(actionType: string) {
    this.auditBenchSummaryInputDTO.actionType = actionType;
    this.auditBenchSummaryInputDTO.ratingId = this.selectedId;
    this.auditBenchSummaryInputDTO.auditId = this.auditId;
    this.isItemClosed = this.isItemClosed;
    this.auditorBenchService.performOperation(this.auditBenchSummaryInputDTO).subscribe(
      (data: any) => {
        this.parsedJson = JSON.parse(JSON.stringify(data));
        if (actionType == 'C' && data.p_status == 1) {
          let updateCount = 0;
          updateCount = parseInt(data.p_upd_count);
          if (updateCount == 0) {
            this.customMessage.showErrorMessage(
              'cams.label.auditorSummary.pendingItemsAreInDraftModeCannotBeClosed',
              ''
            );
            return false;
          }
          let closedCount = parseInt(this.auditSummaryItemCountBean.closed);
          let pendingCount = parseInt(this.auditSummaryItemCountBean.pendingItems);

          closedCount = updateCount + closedCount;
          pendingCount = pendingCount - updateCount;
          if (pendingCount < 0) {
            pendingCount = 0;
            this.auditSummaryItemCountBean.pendingItems = '0';
          } else {
            this.auditSummaryItemCountBean.pendingItems = pendingCount.toString();
          }

          if (closedCount < 0) {
            closedCount = 0;
            this.auditSummaryItemCountBean.closed = '0';
          } else {
            this.auditSummaryItemCountBean.closed = closedCount.toString();
          }
          if (parseInt(this.auditSummaryItemCountBean.pendingItems) > 0) {
            this.isItemClosed = '0';
            this.customMessage.showSuccessMessage(
              'cams.label.common.operationCompletedSuccessfullyButSomeItemsAreInDraftMode'
            );
          } else {
            this.isItemClosed = '1';
            this.customMessage.showSuccessMessage(
              'cams.label.common.operationCompletedSuccessfully'
            );
          }
        }

        this.closePopup();
      },
      error => {
        //------getting data---->>14<<--------->> Cannot Finalize audit is in workflow AUDITOR BENCH SUMMARY
        this.closePopup();

        this.customMessage.showErrorMessage(error.error.msgId, error.error.message);
      }
    );
  }
}
